export default defineNuxtRouteMiddleware((to) => {
    const config = useRuntimeConfig()

    console.log('....................................')
    // Configuration des fonctionnalités disponibles
    const availableFeatures = [
        'dashboard',
        'profile',
        'users',
        'roles',
        'contact-requests'
    ]
    // Configuration des fonctionnalités indisponibles
    const unavailableFeatures = [
        'clients',
        'documents',
        'incidents',
        'projects',
        'reports',
        'settings',
        'tasks',
        // 'users'
    ]

    // Routes principales autorisées
    const publicRoutes = [
        '/',
        '/about-us',
        '/auth/login',
        '/privacy-policy',
        '/services',
        '/about',
        '/contact',
        '/faq',
        '/realisations',
        '/admin',
        '/admin/profile',
        '/admin/contact-requests',
        '/admin/roles',
        '/admin/users'
    ]
    const likelihoodRoutes = publicRoutes.filter(el => to.path.toString().startsWith(el) && to.path !== '/' && el !== '/')
    // Si c'est une route publique, laisser passer
    console.log(likelihoodRoutes, to.path)
    if (!publicRoutes.includes(to.path) && likelihoodRoutes.length === 0) {
        // // Extraire le nom de la fonctionnalité qui match la route
        // const featureName = unavailableFeatures.find(el => to.path.includes(el))
        console.log(likelihoodRoutes, to.path)
        // // Si la fonctionnalité n'est pas activée, rediriger
        // if (featureName && featureName.length > 0) {
        //     console.log('featureName', featureName)
        //     throw createError({
        //         statusCode: 404
        //     })
        // }
        throw createError({
            statusCode: 404
        })
    }
})